import React from 'react';
import styled, { keyframes } from 'styled-components';

const float = keyframes`
  0% {
    transform: translateY(0px);
    box-shadow: 0 5px 15px rgba(0, 77, 64, 0.2);
  }
  50% {
    transform: translateY(-6px);
    box-shadow: 0 15px 25px rgba(0, 77, 64, 0.3);
  }
  100% {
    transform: translateY(0px);
    box-shadow: 0 5px 15px rgba(0, 77, 64, 0.2);
  }
`;

const ripple = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
`;

const ButtonContainer = styled.div`
  position: relative;
  display: inline-block;
  margin-top: 20px;
`;

const RippleEffect = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  border: 2px solid rgba(0, 77, 64, 0.3);
  border-radius: 30px;
  animation: ${ripple} 2s ease-out infinite;
`;

const StyledButton = styled.button<{ $isHovered: boolean }>`
  position: relative;
  padding: 15px 35px;
  font-family: 'Quicksand', sans-serif;
  font-size: 1.1rem;
  font-weight: 500;
  color: #004d40;
  background: rgba(255, 255, 255, 0.9);
  border: 2px solid #004d40;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  animation: ${float} 3s ease-in-out infinite;
  backdrop-filter: blur(5px);

  &:hover {
    background: #004d40;
    color: white;
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0, 77, 64, 0.2);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 5px 10px rgba(0, 77, 64, 0.2);
  }
`;

interface FloatingButtonProps {
  onClick: () => void;
  children: React.ReactNode;
}

const FloatingButton: React.FC<FloatingButtonProps> = ({ onClick, children }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <ButtonContainer
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isHovered && <RippleEffect />}
      <StyledButton onClick={onClick} $isHovered={isHovered}>
        {children}
      </StyledButton>
    </ButtonContainer>
  );
};

export default FloatingButton;
